import { Sun01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Sun = /* @__PURE__ */ createIcon(Sun01Icon, 'Sun');
